import { ISidebarState } from './Interface'
import { MutationTree } from 'vuex'
import { SidebarMutationTypes } from './Types'

export const mutations: MutationTree<ISidebarState> = {
    [SidebarMutationTypes.M_SET_SIDEBAR_SHOW](state, payload: boolean) {
        state.sidebarShow = payload;
    },
}
